import { extractPersonFromJsonLd } from './index';
export var extractPersonUpdatedBy = function extractPersonUpdatedBy(jsonLd) {
  var updatedBy = jsonLd['atlassian:updatedBy'];
  if (updatedBy) {
    return extractPersonFromJsonLd(updatedBy);
  }
};